import { useEffect, useMemo, useState } from 'react';
import {
  AiSignalsAssetKindNav,
  isAiSignalsAssetKindForProfile,
  resolveAiSignalsAssetKindFilter,
  resolveAiSignalsAssetKindProfile,
  type AiSignalsAssetKind,
} from '@terra/ui-ai-applications';
import { TARGET_TYPE } from '../utils/target-scope.utils';
import { useAiApplication } from './api/useAiApplication';

export { AiSignalsAssetKindNav };

export const useAiSignalsKindFilter = ({
  targetId,
  targetType,
}: {
  targetId?: string;
  targetType?: string | null;
}) => {
  const isAiApplication = targetType === TARGET_TYPE.AI_APPLICATION;
  const [selectedKind, setSelectedKind] = useState<AiSignalsAssetKind>('all');

  const { aiApplication } = useAiApplication({
    aiApplicationId: isAiApplication ? (targetId ?? null) : null,
    enabled: isAiApplication && Boolean(targetId),
  });

  const profile = useMemo(
    () =>
      resolveAiSignalsAssetKindProfile({
        applicationKind: aiApplication?.kind,
      }),
    [aiApplication?.kind],
  );

  useEffect(() => {
    if (!isAiSignalsAssetKindForProfile(selectedKind, profile)) {
      setSelectedKind('all');
    }
  }, [profile, selectedKind]);

  const kindFilter = useMemo(
    () =>
      resolveAiSignalsAssetKindFilter({
        kind: selectedKind,
        profile,
      }),
    [profile, selectedKind],
  );

  return {
    isAiApplication,
    selectedKind,
    setSelectedKind,
    profile,
    componentTypes: kindFilter.componentTypes,
    includeApplicationLevelGroup: false,
    isFilterPending: false,
  };
};
